<nav class="stk-sidebar" [class.opened]="isMobileMenuOpen()">
    <div class="stk-sidebar__logo">
        <img src="../../assets/stokker_logo_transparent.png" alt="Stokker">
    </div>
    <!-- Profil + harang: az értesítések oldalra visz -->
    <a class="stk-sidebar__me" routerLink="/ertesitesek" routerLinkActive="active" title="Értesítések">
        <span class="stk-sidebar__me-avatar" [style.background]="meColor">
            <img *ngIf="meImage" [appFetchUserImage]="meImage" alt="">
            <span class="stk-sidebar__me-initial">{{ meInitial }}</span>
        </span>
        <span class="stk-sidebar__me-name">{{ meName }}</span>
        <span class="stk-sidebar__bell" [class.stk-sidebar__bell--on]="notifUnread > 0">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M6 16 V11 a6 6 0 0 1 12 0 v5 l1.5 2 H4.5 Z"></path><path d="M10 20 a2 2 0 0 0 4 0"></path></svg>
            <span class="stk-sidebar__bell-count" *ngIf="notifUnread > 0">{{ notifUnread > 99 ? '99+' : notifUnread }}</span>
        </span>
    </a>
    <div class="stk-sidebar__nav">
        <ng-container *ngFor="let item of visibleNavItems">
            <a class="stk-sidebar__item"
               [routerLink]="linkOf(item)"
               [class.active]="isOpen(item)">
                <span class="stk-sidebar__icon" [innerHTML]="item.icon"></span>
                <span class="stk-sidebar__label">{{ item.label }}</span>
                <span class="stk-sidebar__badge" *ngIf="item.children && !isOpen(item) && parentBadge(item) > 0 && visibleChildren(item).length > 1">{{ parentBadge(item) }}</span>
                <span class="stk-sidebar__badge" *ngIf="item.link === '/chat' && chatUnread > 0">{{ chatUnread > 99 ? '99+' : chatUnread }}</span>
                <span class="stk-sidebar__dot" *ngIf="isOpen(item) && !item.children && !(item.link === '/chat' && chatUnread > 0)"></span>
            </a>
            <!-- Almenü: lenyílik, ha a csoport valamelyik oldalán vagy -->
            <div class="stk-sidebar__sub" *ngIf="item.children && isOpen(item)">
                <a class="stk-sidebar__subitem" *ngFor="let child of visibleChildren(item)"
                   [routerLink]="child.link"
                   routerLinkActive="active"
                   [routerLinkActiveOptions]="child.exact ? exactPathOnly : { exact: false }">
                    <span class="stk-sidebar__sublabel">{{ child.label }}</span>
                    <span class="stk-sidebar__badge" *ngIf="badgeOf(child) > 0">{{ badgeOf(child) }}</span>
                </a>
            </div>
        </ng-container>
    </div>
    <div class="stk-sidebar__spacer"></div>
    <a class="stk-sidebar__item stk-sidebar__item--secondary"
       *ngIf="canSeeSettings"
       routerLink="/settings"
       routerLinkActive="active"
       #rlaSettings="routerLinkActive">
        <span class="stk-sidebar__icon" [innerHTML]="settingsIcon"></span>
        <span class="stk-sidebar__label">Beállítások</span>
        <span class="stk-sidebar__dot" *ngIf="rlaSettings.isActive"></span>
    </a>
    <div class="stk-sidebar__item stk-sidebar__item--secondary" (click)="logout()">
        <span class="stk-sidebar__icon" [innerHTML]="logoutIcon"></span>
        <span class="stk-sidebar__label">Kijelentkezés</span>
    </div>
</nav>
<div class="shadow-layer" (click)="closeMenu()" [class.show]="isMobileMenuOpen()"></div>
